import useAuth from "@/components/auth/useAuth"
import usePreferences from "@/components/auth/usePreferences"
import MODULE_TYPES from "@/constants/MODULE_TYPES"
import React from "react"
import { Redirect as BaseRedirect } from "react-router-dom"

export default function Redirect() {
  const { user } = useAuth()
  const { assetType } = usePreferences()

  const o = MODULE_TYPES.OWNER
  const c = MODULE_TYPES.CONSULTANT
  const m = MODULE_TYPES.MANAGER

  const mod = user?.organisation?.modules
  const isOwner = mod?.includes(o)
  const isConsultant = mod?.includes(c)
  const isManager = mod?.includes(m)
  const isClient = mod?.includes("client")
  const hasAssetList = mod?.includes("Asset List")

  const redirect = (type: string | null, mod: string) =>
    type === "benchmark" ? (
      <BaseRedirect to={`/${mod}/mandates`} />
    ) : (
      <BaseRedirect to={`/${mod}/overview`} />
    )

  if (isOwner) {
    return redirect(assetType, o)
  }

  if (isManager) {
    return <BaseRedirect to="/manager/clients" />
  }

  if (isClient) {
    return <BaseRedirect to="/client/spcs" />
  }

  if (isConsultant) {
    return hasAssetList ? (
      <BaseRedirect to="/consultant/assetList" />
    ) : (
      redirect(assetType, c)
    )
  }

  if (user?.superuser) {
    return <BaseRedirect to="/admin/organisations" />
  }

  return <BaseRedirect to="/research" />
}
